import { Component, OnInit, Inject } from '@angular/core';

// modal
import {  MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { FormControl }  from '@angular/forms'; 

// servicio
import { FinanzasService } from 'app/finanzas/finanzas.service';

// entidades
import { Bitacora, Usuario, Dependencia, Puc, Subdependencia, Query } from '../../../entidades';

//
import { isNumber } from 'util';
import { AggPucComponent } from '../../agg-puc/agg-puc.component';
import Swal from 'sweetalert2';


declare var jQuery:any;
declare var $:any;


@Component({
  selector: 'app-form-ingresos',
  templateUrl: './form-ingresos.component.html',
  styleUrls: ['./form-ingresos.component.css'], 
})
export class FormIngresos implements OnInit {

  movimiento: Bitacora = new Bitacora();
  cuenta : Puc = new Puc();

  checked = false;
  area: number;
  dependencia : number;
  
  dependencias: Array<Dependencia>;                 // Guarda los datos que vienen del servicio getDependencias
  subdependencias: Array<Subdependencia>;            // Guarda los datos que vienen del servicio  getSubdependencias
  usuarios: any;                         // Guarda los datos que vienen del servicio getUsuarios

    // datos que se reciben del modal 
  puc = this.datos.puc;
  areas = this.datos.areas;
  ingresos = this.datos.ingresos;
  id_gasto = this.datos.id_gasto;    
  anio = this.datos.anio;
  mes = this.datos.mes;
  listT = this.datos.listM; 

  public ngxControl = new FormControl();
  public items: any[] = this.puc;
  public ngxValue: any[];

  constructor(
    public dialogRef: MatDialogRef<FormIngresos>, 
    @Inject(MAT_DIALOG_DATA) private datos,
    public servicios: FinanzasService,   
    private dialog:MatDialog  ) {
      this.ingresos = []
      this.ingresos = this.datos.ingresos;
      this.movimiento["tipo"]=1;
      this.movimiento["id_empresa"]= this.datos.empresa; 
      this.movimiento['anio'] = this.anio;
      this.movimiento['mes'] = this.mes;
      
      
  }

    ngOnInit(  ){    
    this.buscarId( this.id_gasto )
    }

  buscarId(id_gasto) {
    let list;
    if (this.listT == undefined) {
      list = this.ingresos
    }
    else if (this.listT == true) {
      list = this.ingresos
    }
    else {
      list = this.ingresos[this.mes]
    }
    for (const i of list) {
      if (i.id_gasto == id_gasto) {
        this.movimiento = i
      }
    }
  }

  
    

    agregarPuc(): void {
      const dialogRef = this.dialog.open(AggPucComponent, {
        width: '500px',
        data :{
          empresa : this.datos.empresa,
        }
    });
  
    dialogRef.afterClosed().subscribe(result => {
        this.cuenta = result;
        this.guardarCuenta()
      });
    }

    buscarCodigo(  ){  
      let codigoTemp  =  this.cuenta['codigo']
      if (this.puc.find(element => element.codigo == codigoTemp)  ){
          return true
      }
    }

    
  public buscarDependencias():void{
    this.area = this.movimiento["id_area"]
    this.servicios.getDependencias(this.movimiento["id_area"]).subscribe( (resp: Array<Dependencia>) => {this.dependencias=resp} )
  }

  public buscarSubdependencias():void{
    this.dependencia = this.movimiento["id_dependencia"];
    this.servicios.getSubdependencias(this.movimiento["id_dependencia"]).subscribe( (resp:Array<Subdependencia>) => {this.subdependencias=resp; } )
  }

  public buscarUsuarios(): void {
    const selectedSubdependencia = this.movimiento['id_subdependencia'];
    
    if( !isNumber(selectedSubdependencia))  {
      this.servicios.getUsuarios_filter(this.area, this.dependencia  )
      .subscribe( (resp : Array<Usuario>   )   => {
        this.usuarios = resp;
        
      }); 
    }
    
    else { 
      this.servicios.getUsuarios( this.area, this.dependencia, selectedSubdependencia)
      .subscribe( (resp: Array<Usuario>) => {
        this.usuarios = resp;     
        
      });
    }  
  }

  guardarCuenta() {
    if (this.buscarCodigo() == true) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'La cuenta ya existe',
      })
    }
    else {
      this.servicios.addCuenta(this.cuenta)
        .subscribe((status: Query) => {
          const affectedRows = status.affectedRows
          if (affectedRows != 0) {
            Swal.fire({
              type: 'success',
              title: 'La cuenta fue añadida correctamente'
            })
            this.servicios.getPuc(this.cuenta['idEmpresa']).subscribe((resp) => { this.puc = resp })

          }
          else {
            Swal.fire({
              type: 'error',
              title: 'La cuenta no se pudo añadir'
            })
          }
        })
    }
  }

}
